import type { TourConfig } from "~/features/onboarding/types/tour-config";

// AIDEV-NOTE: Onboarding-checklist coach-mark. The "Generate a consultation"
// item navigates to /practitioner/sessions and starts this tour, highlighting
// the per-session "Consultation" button (data-tour-id="consult-button").
export const consultCalloutTourConfig: TourConfig = {
    id: "consult-callout",
    page: "/practitioner/sessions",

    welcome: {
        title: "Generate a consultation",
        description:
            "Open a session's Consultation to get an AI-generated analysis of it.",
        startButtonText: "Show me",
        skipButtonText: "Skip",
    },

    steps: [
        {
            id: "consult-button",
            targetSelector: "[data-tour-id='consult-button']",
            title: "Generate a consultation",
            content:
                "Click Consultation on any session for a detailed, AI-generated analysis — key therapeutic moments, part dynamics, and areas worth exploring, like a thoughtful colleague reviewing your session with you.",
            position: "left",
            disableBackdropClose: true,
        },
    ],
};
